import { defineComponent as _defineComponent } from 'vue';
import Button from 'primevue/button';
import InputText from 'primevue/inputtext';
import Menu from 'primevue/menu';
import { ref } from 'vue';
import { useAxios } from '../Plugins/axios';
import { useSpinner } from '../Plugins/spinner';
import { useToastService } from '../Plugins/toast-service';
import ConfirmationService from '../Services/ConfirmationService';
export default /*#__PURE__*/ _defineComponent({
    __name: 'RecordsTableHeader',
    props: {
        selectedRecords: {
            type: Array,
            default: [],
        },
        filters: Object,
        route: String,
        showBulkActions: {
            type: Boolean,
            default: true,
        },
    },
    emits: ['deleted'],
    setup(__props, { expose, emit }) {
        expose();
        const props = __props;
        const spinner = useSpinner();
        const axios = useAxios();
        const toast = useToastService();
        const confirmationService = new ConfirmationService();
        const bulkActionsMenu = ref();
        const bulkActions = ref([
            {
                label: 'Elimina Selezionati',
                icon: 'pi pi-fw pi-trash',
                command: () => deleteSelected(),
                disabled: () => props.selectedRecords.length === 0,
            },
        ]);
        const deleteSelected = () => {
            confirmationService.confirmDeleteMultiple(props.selectedRecords.length, () => {
                spinner.show();
                axios
                    .post(props.route || '', {
                    _method: 'DELETE',
                    ids: props.selectedRecords.map((p) => p.id),
                })
                    .then(() => {
                    emit('deleted');
                    toast.deleteSuccess();
                })
                    .finally(() => {
                    spinner.hide();
                });
            }, () => { });
        };
        const __returned__ = { props, emit, spinner, axios, toast, confirmationService, bulkActionsMenu, bulkActions, deleteSelected, get Button() { return Button; }, get InputText() { return InputText; }, get Menu() { return Menu; } };
        Object.defineProperty(__returned__, '__isScriptSetup', { enumerable: false, value: true });
        return __returned__;
    }
});
